let uidCounter = 0
const prefix = "tpm-uid"

export function uniqueId() {
  const uid = [prefix, uidCounter].join("-")
  uidCounter += 1
  return uid
}



/** WEBPACK FOOTER **
 ** ./lib/unique_id.js
 **/